import BaseAPIService from '../base/base-api-service';
import WarrantyModel from 'src/model/warranty.model';

class WarrantyService extends BaseAPIService<WarrantyModel> {
  public endpoint: string = '/navapp/v1/warranty';

  constructor() {
    super(WarrantyModel);
  }

  public getWarranties(): Promise<WarrantyModel> {
    return this.getOneByParams(this.endpoint, {}, {});
  }
}

const warrantyServiceInstance = new WarrantyService();
Object.freeze(warrantyServiceInstance);

export default warrantyServiceInstance;
